import React from 'react';
import PropTypes from 'prop-types';

class VisibleOn extends React.PureComponent {
    static defaultProps = {
        visibleOn: 'all',
    };

    static propTypes = {
        visibleOn: PropTypes.oneOf([
            'all',
            'hd-desktop',
            'desktop',
            'not-desktop',
            'tablet',
            'not-mobile',
            'mobile',
        ]),
    };

    constructor(props) {
        super(props);
        this.domElWrapper = React.createRef();
        this.state = { visible: this._updateDimensions(false) };
        this.updateDimHandler = () => {
            this._updateDimensions();
        };
    }

    componentDidMount() {
        window.addEventListener('resize', this.updateDimHandler);
        this.updateDimHandler();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimHandler);
    }

    _updateDimensions(triggerStateUpdate = true) {
        if (typeof window === 'undefined') return false;

        let visible = true;
        switch (this.props.visibleOn) {
            case 'hd-desktop':
                visible = window.innerWidth >= 1500;
                break;
            case 'desktop':
                visible = window.innerWidth >= 900;
                break;
            case 'not-desktop':
                visible = window.innerWidth < 900;
                break;
            case 'tablet':
                visible = window.innerWidth >= 600 && window.innerWidth < 900;
                break;
            case 'mobile':
                visible = window.innerWidth < 600;
                break;
            case 'not-mobile':
                visible = window.innerWidth >= 600;
                break;
            default:
                break;
        }

        if (
            triggerStateUpdate &&
            this.state !== undefined &&
            visible !== this.state.visible
        ) {
            this.setState({ visible });
        }

        return visible;
    }

    render() {
        const { visible } = this.state;
        if (visible)
            return <React.Fragment>{this.props.children}</React.Fragment>;

        return null;
    }
}

export default VisibleOn;



// WEBPACK FOOTER //
// ./src/components/common/visibleOn/VisibleOn.jsx